<template lang="pug">
  .body.house-table.body-flex
    .table-choose-panel.body-flex
      .toolbar-table.toolbar.toolbar_no-padding.toolbar_margin-bottom
        .toolbar__line.line.line_full-width.line_space-between
          .select.select_no-border.semibold Обслуживаемые дома
          .toolbar.toolbar--modal.toolbar_no-padding
            .line.toolbar__line
              .actions-panel
                e-button-add.btn-add-target.actions-panel__button.view-panel__button.view-panel__button_add(@click="addNewRowToTable()" label="Добавить" )
      e-table-editable(
        ref="houses"
        :attributes="garbageDetailAttr"
        :dataUrl="garbageDataUrl"
        :postUrl="garbagePostUrl"
        :patchUrl="garbagePatchUrl"
        :deleteUrl="garbageDeleteUrl"
        :tableInOnlineMode="tableInOnlineMode"
        :afterFetchData="afterFetchData"
        @sortByField="onSortByField"
        :afterValidate="afterValidate"
      )
</template>

<script>
import { garbage, housing } from '@/api/api-endpoints'
import { garbageOffline } from '@/api/api-offline-endpoints'

export default {
  name: 'house-table',
  props: {
    tabView: null,
    id: null,
  },
  data() {
    return {
      search: '',
      searchModel: '',
      sort: null,
    }
  },
  computed: {
    tableInOnlineMode() {
      return this.$route.params.id
    },
    operationType() {
      return 'houses'
    },
    garbageDetailAttr() {
      return {
        houseName: {
          label: 'Адрес',
          placeholder: 'Начните вводить адреса',
          validationRulePattern: '(\\.*)',
          sort: true,
          sortName: 'house_id',
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions,
          },
        },
        residence_number: {
          label: 'Количество прописанных',
          validationRulePattern: '(\\.*)',
          placeholder: ' - ',
          disabled: true,
        },
      }
    },
    garbageDataUrl() {
      if (this.id) {
        let routeQuery = {
          query: {
            sourceId: this.id,
          },
        }
        if (this.search) {
          routeQuery.query.q = this.search
        }
        if (this.sort) {
          routeQuery.query.sort = this.sort
        }

        return garbage.garbageHouses(routeQuery)
      }
      return garbageOffline.houseTable(this.$route.name)
    },
    housesIdModelMap() {
      let map = {}
      if (
        this.$refs.houses &&
        this.$refs.houses.data &&
        this.$refs.houses.data.data
      ) {
        this.$refs.houses.data.data.forEach((row) => {
          if (row.house_id) {
            if (!map[row.house_id]) {
              map[row.house_id] = []
            }
            map[row.house_id].push(row)
          }
        })
      }
      return map
    },
  },
  methods: {
    afterValidate(ctx, model, errors) {
      if (model.house_id && this.housesIdModelMap[model.house_id]) {
        let rows = this.housesIdModelMap[model.house_id]
        let isCurrentModel = false
        rows.forEach((row) => {
          isCurrentModel = false
          if (model.id && model.id == row.id) {
            isCurrentModel = true
          } else if (model._storeUUID == row._storeUUID) {
            isCurrentModel = true
          }
          if (!isCurrentModel) {
            errors.houseName = 'Данный дом уже добавлен'
          }
        })
      }
      return errors
    },
    letSearch() {
      this.search = JSON.parse(JSON.stringify(this.searchModel))
    },
    onSortByField({ sort }) {
      this.sort = sort
    },
    onSelect(ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.house_id = copy.id
        model.houseName = copy.name
        if (copy.houseDetails) {
          copy.houseDetails.forEach((h) => {
            model.residence_number = h.residence_number
          })
        }
      } else {
        model.house_id = ''
        model.houseName = ''
        model.residence_number = ''
      }
    },
    suggestionEndpoint(ctx, q) {
      return housing.houses({ query: { q, 'per-page': 50 } })
    },
    transformSuggestions(ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].address,
          ...data[i],
        })
      }
      return options
    },
    afterFetchData(ctx, data) {
      let houseObjInfoKey = 'house'
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i][houseObjInfoKey]) {
          data.data[i].houseName = data.data[i][houseObjInfoKey].address
          data.data[i].house_id = data.data[i][houseObjInfoKey].id
          if (data.data[i][houseObjInfoKey].houseDetails) {
            data.data[i][houseObjInfoKey].houseDetails.forEach((h) => {
              data.data[i].residence_number = h.residence_number
            })
          }
        }
      }
      return data
    },
    garbagePostUrl() {
      return garbage.garbageHousePost({
        query: {
          sourceId: this.id,
        },
      })
    },
    garbagePatchUrl(context, model) {
      return garbage.garbageHousePatch({
        query: {
          sourceId: model.id,
        },
      })
    },
    garbageDeleteUrl(context, model) {
      return garbage.garbageHouseDelete({
        query: {
          sourceId: model.id,
        },
      })
    },
    addNewRowToTable() {
      const Model = () => {
        return {
          house_id: '',
          houseName: '',
          residence_number: '',
        }
      }
      this.$refs.houses.createRow(new Model())
    },
  },
}
</script>
